import React from 'react'
import { Button, Card, Typography, Space, message } from 'antd'
import MD5 from 'crypto-js/md5'
import { getToken } from '@/utils/token'

const { Title, Paragraph } = Typography

const DanceStepCutTransfer = () => {
  const handleOpen = () => {
    const baseUrl = 'https://dev.cross1000.com/design-resource-admin.html'
    try {
      const raw = getToken()
      if (!raw) {
        window.open(baseUrl, '_blank', 'noopener,noreferrer')
        return
      }
      const parsed = JSON.parse(raw)
      const token = parsed?.token
      if (!token) {
        window.open(baseUrl, '_blank', 'noopener,noreferrer')
        return
      }
      const t = MD5(token).toString()
      const url = `${baseUrl}?t=${t}`
      window.open(url, '_blank', 'noopener,noreferrer')
    } catch (err) {
      message.error('无法读取本地令牌，已为您打开默认页面')
      window.open(baseUrl, '_blank', 'noopener,noreferrer')
    }
  }

  return (
    <Card>
      <Typography>
        <Title level={4}>完整舞步裁切迁移</Title>
        <Paragraph>
          1. 可以使用原本平台中的 CSV 打包舞步进行裁切和标注。
        </Paragraph>
        <Paragraph>
          2. 标注后的舞步将会自动打包上传到资源库中。
        </Paragraph>
      </Typography>
      <Space>
        <Button type="primary" onClick={handleOpen}>
          前往裁切与迁移页面（新标签打开）
        </Button>
      </Space>
    </Card>
  )
}

export default DanceStepCutTransfer
